//import PageLang from "../../utils/page-lang";
import Popup from '../../utils/popup';
import Tools from '../../utils/tools';
//import Translations from "../../utils/translations";

//import Terminy from "../../karnety/terminy";

class Koszyk {
    constructor() {
        this.settings = {
            podsumowanieDane: {}, //będzie pobrane Ajaxem
            karnetyTerminy: []
        };
    }

    events() {
        const that = this;
        $('.js-koszyk-zmien-termn')
            .off('click')
            .on('click', function(e) {
                e.preventDefault();
                let index = $('.js-koszyk-zmien-termn').index(this);
                let alternatywneTerminyBox = $($('.js-alternatywne-terminy')[index]);
                let params = $(this).data();
                that.pobierzTerminyDlaKarnetu(params, index, alternatywneTerminyBox);
            });

        $('.koszyk-zgody input')
            .off('click')
            .on('click', function() {
                if ($(this).is(':checked')) {
                    $(this).removeClass('is-invalid');
                    let errorDiv = $(this)
                        .parent()
                        .find('.invalid-feedback');
                    if (errorDiv.length > 0) {
                        $(errorDiv).html('');
                    }
                }
            });

        $('#koszyk-submit_dalej').add('#koszyk-submit_dalej_m')
            .off('click')
            .on('click', function(e) {
                e.preventDefault();
                let checkResult = that.checkIfInputsValid();
                console.log(checkResult);

                if (checkResult.isValid) {
                    $('form#koszyk').submit();
                } else {
                    if (checkResult.messages && checkResult.messages.length > 0) {
                        let msg = '';
                        $.each(checkResult.messages, function(messageIndex, messageTxt) {
                            msg += '<div>' + messageTxt + '</div>';
                        });
                        let popup = new Popup(msg);
                        popup.showPopup();
                    }

                    $.each(checkResult.invalidInputs, function(index, input) {
                        if ($(input).hasClass('is-invalid') === false) {
                            $(input).addClass('is-invalid');
                            $(input)
                                .parent()
                                .append(
                                    '<div for="' +
                                    $(input).attr('id') +
                                    '" class="invalid-feedback">' +
                                    '<div>' +
                                    checkResult.messages[index] +
                                    '</div>' +
                                    '</div>'
                                );
                        }
                    });
                }
            });

        $('#koszyk-faktura_nip').off('focusout').on('focusout', function() {
            let nip = $(this).val();
            if (
                nip.length === 10 &&
                parseInt($('#koszyk-faktura_kraj').val()) === 1 //polska
            ) {
                that.getGusData(nip);
            } else if (nip.length !== 10) {
                let popup = new Popup(
                    translates.nip_zla_dlugosc
                );
                popup.showPopup();
            }
        });

        $('.abonaments__dates__item input[type=checkbox]')
            .off('click')
            .on('click', function(e) {
                e.preventDefault();
                let nowyTerminId = parseInt($(this).val());
                let terminyWrapper = $(this).parents('.js-alternatywne-terminy');

                let poprzedniTerminId = parseInt($(terminyWrapper).data('wybrany_termin_id'));
                let idBlokadAsStr = $(terminyWrapper).data('id_blokad');

                if (nowyTerminId !== poprzedniTerminId) {
                    that.zmienTerminWAbonamencie(
                        nowyTerminId,
                        poprzedniTerminId,
                        idBlokadAsStr
                    );
                } else {
                    let popup = new Popup(translates.nie_zmieniono_terminu_dla_abonamentu);
                    popup.showPopup();
                }
            });

        $('.js-usun-karnet')
            .off('click')
            .click(function(e) {
                e.preventDefault();
                let identyfikatoryBlokad = $(this).data('idt_blokad');
                let popup = new Popup(translates.usun_potwierdz);
                popup.onConfirm = function() {
                    that.usunKarnet(identyfikatoryBlokad);
                };
                popup.showPopup();
            });

        $('.cart-table select')
            .off('change')
            .on('change', function() {
                let nameSplit = $(this)
                    .attr('name')
                    .split('_');
                let nameSplitReversed = nameSplit.reverse();
                let pozycjaCennikaId = $(this).val();

                if (pozycjaCennikaId > 0) {
                    let params = {
                        json: true,
                        jsonType: 'zmien_pozycje_cennika',
                        termin_id: nameSplitReversed[1],
                        ter_id: nameSplitReversed[1],
                        ter_idt: nameSplitReversed[1],
                        miejsce_id: nameSplitReversed[0],
                        nowa_pozycja_id: pozycjaCennikaId
                    };

                    that.zmienPozycjeCennika(params);
                }
            });

        $('[name="koszyk-ukryj_cene"]')
            .off('click')
            .on('click', function() {
                let ukryjValue = $(this).is(':checked') ? 1 : 0;
                that.ukryjCene(ukryjValue);
            });

        $('.js-kod-rabatowy-dodaj')
            .off('click')
            .on('click', function(e) {
                e.preventDefault();
                if ($('#kodRabatowy').is(':visible')) {
                    $('#kodRabatowy')
                        .removeClass('d-block')
                        .addClass('d-none');
                } else {
                    $('#kodRabatowy')
                        .removeClass('d-none')
                        .addClass('d-block');
                }
            });

        $('.js-karta-przedplacona-dodaj')
            .off('click')
            .on('click', function(e) {
                e.preventDefault();
                if ($('#kartaPrzedplaconaInput').is(':visible')) {
                    $('#kartaPrzedplaconaInput')
                        .removeClass('d-block')
                        .addClass('d-none');
                } else {
                    $('#kartaPrzedplaconaInput')
                        .removeClass('d-none')
                        .addClass('d-block');
                }
            });

        $('#button-kod-zatwierdz')
            .off('click')
            .on('click', function() {
                that.zastosujRabat($('#koszyk-kod').val());
            });

        $('#button-karta-zatwierdz')
            .off('click')
            .on('click', function() {
                that.wprowadzNumerKartyPrzedplaconej($('#koszyk-karta_przedplacona_numer').val());
            });

        $('.js-kup-goscinnie')
            .off('click')
            .on('click', function(e) {
                e.preventDefault();
                $('[href="#delivery"]').tab('show');
                window.scrollTo(0, 0);
                // if ($("body").hasClass("mobile")) {
                //   that.pobierzPodsumowanie();
                // }
            });

        $('[name="koszyk-zachowane_dane_do_faktur"]')
            .off('change')
            .on('change', function() {
                if (parseInt($(this).val()) === -1) {
                    $('.js-dane-do-faktur-wrapper').slideDown();
                    $('#koszyk-faktura_id_kontrahenta').val('');
                    $('#koszyk-faktura_identyfikator_kontrahenta').val('');
                } else {
                    $('.js-dane-do-faktur-wrapper').slideUp();
                    $('#koszyk-faktura_id_kontrahenta').val($(this).val());
                    let identyfikator = $(this)
                        .parent()
                        .find('.js-df-identyfikator')
                        .data('identyfikator');
                    $('#koszyk-faktura_identyfikator_kontrahenta').val(identyfikator);
                }
            });

        $('[name="koszyk-zachowane_adresy_dostaw"]')
            .off('change')
            .on('change', function() {
                if (parseInt($(this).val()) === -1) {
                    $('.js-nowy-adres-dostawy-wrapper').slideDown();
                } else {
                    $('.js-nowy-adres-dostawy-wrapper').slideUp();
                }
            });

        $('[name="koszyk-sposobydostawy"]')
            .off('change')
            .on('change', function() {
                // let sposobDostIndex = $(this).index();

                that.ustawSposobDostawy($(this).val());

                let sposobDostawyIndex = 0;
                $.each($('[name="koszyk-sposobydostawy"]'), function(
                    index,
                    radiobutton
                ) {
                    if ($(radiobutton).is(':checked')) {
                        sposobDostawyIndex = index;
                    }
                });

                let labelHeader = $(
                    $('.js-nazwa-sposobu-dost-bold')[sposobDostawyIndex]
                );
                if (labelHeader) {
                    let czyWymaganyAdresDostawy = labelHeader.data('adres_wymagany');
                    if (czyWymaganyAdresDostawy) {
                        $('.js-koszyk-adres-dostawy').slideDown();
                    } else {
                        $('.js-koszyk-adres-dostawy').slideUp();
                    }
                }
            });

        $('#invoice-radioboxes label')
            .off('click')
            .on('click', function() {
                let index = $('#invoice-radioboxes label').index(this);
                let index_other = index === 0 ? 1 : 0;
                $(this)
                    .find('.js-faktura_rodzaj')
                    .attr('checked', 'checked');

                $($('.js-faktura_rodzaj')[index_other]).removeAttr('checked');

                if (index === 0) {
                    $('#faktura_osoba_pola').show();
                    $('#faktura_firma_pola').hide();
                } else {
                    $('#faktura_osoba_pola').hide();
                    $('#faktura_firma_pola').show();
                }
            });

        $('.js-faktura-checkbox')
            .off('click')
            .on('click', function() {
                let inputFaktura = $(this).find('input[name=koszyk-faktura]');
                let customCheckbox = $(this).find('span.custom-checkbox');
                let checkboxLabel = $(this).find('label');
                setTimeout(function() {
                    if ($(this).hasClass('collapsed')) {
                        $(inputFaktura).removeAttr('checked');
                        $(customCheckbox).removeClass('checked');
                        $(checkboxLabel).removeClass('checked');
                    } else {
                        $(inputFaktura).attr('checked', 'checked');
                        $(customCheckbox).addClass('checked');
                        $(checkboxLabel).addClass('checked');

                        let checkedDfSelector = $(
                            '[name="koszyk-zachowane_dane_do_faktur"]:checked'
                        );
                        let wybraneDaneDoFakturId = $(checkedDfSelector).val();
                        if (wybraneDaneDoFakturId) {
                            let identElem = $(checkedDfSelector)
                                .parent()
                                .find('.js-df-identyfikator');

                            let identyfikator = '';
                            if (identElem) {
                                identyfikator = $(identElem).data('identyfikator');
                            }

                            $('#koszyk-faktura_id_kontrahenta').val(wybraneDaneDoFakturId);
                            $('#koszyk-faktura_identyfikator_kontrahenta').val(identyfikator);
                        }
                        //);
                    }
                }, 100);
            });

        $('#koszykDalejBtn')
            .off('click')
            .on('click', function(e) {
                e.preventDefault();
                $('#delivery-tab').click();
                $('html, body').animate({ scrollTop: 0 }, 'slow');
            });

        //działa przy zmianie zakładek
        $('a[data-toggle="tab"]')
            .off('shown.bs.tab')
            .on('shown.bs.tab', function(e) {
                let newlyActiveTab = $(e.target);
                let previousActiveTab = $(e.relatedTarget);
                //newlyActiveTab.addClass("testtestpp");
                //previousActiveTab.removeClass("testtestpp");

                if (newlyActiveTab.attr('id') === 'delivery-tab') {
                    that.pobierzPodsumowanie();

                    if ($('[name="koszyk-adres_inny"]').is(':checked')) {
                        $('#collapseAdres').addClass('show');
                    } else {
                        $('#collapseAdres').removeClass('show');
                    }
                }

                if (newlyActiveTab.attr('id') === 'summary-tab') {
                    let checkResult = that.checkIfInputsValid();
                    if (checkResult.isValid === false) {
                        // let popupMessage = '<div style="color: red">'+checkResult.messages.join('<br />')+'</div>';

                        $('#delivery-tab').click();
                        let popup = new Popup(
                            translates.blad_walidacji
                        );
                        popup.showPopup();

                        $.each(checkResult.invalidInputs, function(index, input) {
                            if ($(input).hasClass('is-invalid') === false) {
                                $(input).addClass('is-invalid');
                                $(input)
                                    .parent()
                                    .append(
                                        '<div for="' +
                                        $(input).attr('id') +
                                        '" class="invalid-feedback">' +
                                        '<div>' +
                                        checkResult.messages[index] +
                                        '</div>' +
                                        '</div>'
                                    );
                            }
                        });
                    } else {
                        that.sprawdzPodsumowanie();
                    }
                }
            });

        $('.js-usun-towar')
            .off('click')
            .on('click', function(e) {
                e.preventDefault();
                let iksorisTowarId = $(this).data('iksoris_towar_id');
                let iksorisTowarCena = $(this).data('iksoris_towar_cena');
                let popup = new Popup(translates.usun_potwierdz);
                popup.onConfirm = function() {
                    that.zmienLiczbeSztukTowaru(iksorisTowarId, iksorisTowarCena, 0);
                };
                popup.showPopup();
            });

        $('.cart-product-item .change-button.plus')
            .off('click')
            .on('click', function() {
                let input = $(this)
                    .parent()
                    .find('input.count');
                let iksorisTowarId = $(input).data('iksoris_towar_id');
                let iksorisTowarCena = $(input).data('iksoris_towar_cena');
                let nowaLiczbaSztukTowaru = $(input).val();

                that.zmienLiczbeSztukTowaru(
                    iksorisTowarId,
                    iksorisTowarCena,
                    nowaLiczbaSztukTowaru
                );
            });
        $('.cart-product-item .change-button.minus')
            .off('click')
            .on('click', function() {
                let input = $(this)
                    .parent()
                    .find('input.count');
                let iksorisTowarId = $(input).data('iksoris_towar_id');
                let iksorisTowarCena = $(input).data('iksoris_towar_cena');
                let nowaLiczbaSztukTowaru = $(input).val();
                that.zmienLiczbeSztukTowaru(
                    iksorisTowarId,
                    iksorisTowarCena,
                    nowaLiczbaSztukTowaru
                );
            });

        if (
            $('input[name="koszyk-faktura_rodzaj_m"]:checked').val() == 2 ||
            $('input[name="koszyk-faktura_rodzaj"]:checked').val() == 2
        ) {
            $('#faktura_firma_pola').show();
            $('#faktura_osoba_pola').hide();
        }
        if (
            $('input[name="koszyk-faktura_rodzaj_m"]:checked').val() == 1 ||
            $('input[name="koszyk-faktura_rodzaj"]:checked').val() == 1
        ) {
            $('#faktura_firma_pola').hide();
            $('#faktura_osoba_pola').show();
        }
    }

    getGusData(nip) {
        $.ajax({
            url: '/koszyk/index.html',
            method: 'get',
            beforeSend: Tools.preloaderShow,
            complete: Tools.preloaderHide,
            data: {
                json: true,
                ajax_action: 'getGusData',
                nip: nip
            },
            success: function(result) {
                if (result && result.status === 'complete') {
                    let gusData = result.data;
                    $('#koszyk-faktura_nazwa').val(gusData.name);
                    $('#koszyk-faktura_ulica').val(gusData.street);
                    $('#koszyk-faktura_numer_budynku').val(gusData.building_number);
                    $('#koszyk-faktura_numer_lokalu').val(gusData.flat_number);

                    $('#koszyk-faktura_kod').val(gusData.postcode);
                    $('#koszyk-faktura_miejscowosc').val(gusData.city);
                } else {
                    if (result.message === 'Element do not exists') {
                        let popup = new Popup(
                            translates.nip_nie_znaleziono
                        );
                        popup.showPopup();
                    }
                }
            },
            error: function(xhr, status, error) {
                //
            }
        });

    }

    zmienLiczbeSztukTowaru(
        iksorisTowarId,
        iksorisTowarCena,
        nowaLiczbaSztukTowaru
    ) {
        $.ajax({
            url: '/towary/szczegoly.html',
            method: 'get',
            data: {
                json: true,
                ajax_action: 'zmien_ilczbe_sztuk_towaru',
                ilosc: nowaLiczbaSztukTowaru,
                cena: iksorisTowarCena,
                towar_iksoris_id: iksorisTowarId
            },
            success: function(result) {
                if (result && result.status === 'complete') {
                    let popup = new Popup(
                        result.successMessage ||
                        'Zaktualizowano liczbę sztuk towaru w koszyku'
                    );
                    popup.onClose = function() {
                        location.reload();
                    };
                    popup.showPopup();
                } else {
                    let popup = new Popup(
                        result.message ||
                        'Wystąpił błąd podczas aktualizacji ilości sztuk towaru w koszyku'
                    );
                    popup.onClose = function() {
                        location.reload();
                    };
                    popup.showPopup();
                }
            },
            error: function(xhr, status, error) {
                console.error(status);
                console.error(error);
            }
        });
    }

    zmienTerminWAbonamencie(nowyTerminId, poprzedniTerminId, idBlokadAsStr) {
        console.log(nowyTerminId);
        console.log(poprzedniTerminId);
        console.log(idBlokadAsStr);
        const that = this;
        $.ajax({
            url: '/koszyk/index.html',
            method: 'get',
            data: {
                json: true,
                ajax_action: 'zmien_termin_w_abonamencie',
                nowyTerminId: nowyTerminId,
                poprzedniTerminId: poprzedniTerminId,
                idBlokadStr: idBlokadAsStr
            },
            success: function(result) {

                if (result && result.status === 'complete') {
                    if (result.terminNiewybraneMiejsca.length === 0) {
                        location.reload();
                    } else {
                        let popupMessage = 'Nie udało się wybrać miejsc: <br /><strong>';
                        $.each(result.terminNiewybraneMiejsca, function(index, row) {
                            popupMessage += row.opis_miejsca;
                            popupMessage += $('body').hasClass('mobile') ? '<br />' : ' ';
                            popupMessage += 'na termin ' + row.termin_opis + '<br />';
                        });
                        popupMessage +=
                            '</strong>W nowo wybranym terminie miejsca te są niedostępne. Proszę wybrać inne miejsca.';
                        let przejdzDoWyboruMiejsca = function() {
                            window.location.href =
                                '/karnety/obiekt.html?definicja=' +
                                result.terminNiewybraneMiejsca[0].definicja_id +
                                '&ter_id=' +
                                result.terminNiewybraneMiejsca[0].termin_id +
                                '&ter_idt=' +
                                result.terminNiewybraneMiejsca[0].termin_idt +
                                '&wiz_id=' +
                                result.terminNiewybraneMiejsca[0].wiz_id;
                        };
                        let popup = new Popup(popupMessage);
                        popup.onClose = przejdzDoWyboruMiejsca;
                        popup.showPopup();
                    }
                } else {
                    let popup = new Popup(
                        result.message ||
                        'Wystąpił błąd w trakcie podmiany terminu w abonamencie'
                    );

                    popup.showPopup();
                }
            },
            error: function(xhr, status, error) {
                console.error(status);
                console.error(error);
                let popup = new Popup(error);
                popup.showPopup();
            }
        });
    }

    pobierzTerminyDlaKarnetu(
        params,
        indexWierszaZTerminami,
        alternatywneTerminyBox
    ) {
        const that = this;
        $.ajax({
            url: '/karnety/terminy.html',
            method: 'get',
            data: $.extend(params, {
                ajax: 'pobierz_terminy_dla_wydarzenia'
            }),
            success: function(result) {
                if (result && result.status === 'complete') {
                    if ($.isEmptyObject(result.data)) {
                        let popup = new Popup(
                            'brak alternatywnych terminów na wybrane wydarzenie'
                        );
                        popup.showPopup();
                    } else {
                        if ($(alternatywneTerminyBox).css('visibility') === 'hidden') {
                            $(alternatywneTerminyBox).css({
                                visibility: 'visible',
                                height: '123px'
                            });
                            $($('.js-koszyk-zmien-termn')[indexWierszaZTerminami]).html(
                                translates.zamknij
                            );
                            let terminyHtml = '';
                            let checkedVal;
                            $.each(result.data.terminy, function(termin_id, row) {
                                checkedVal = row.wybrany ? 'checked' : '';
                                terminyHtml +=
                                    '<label class="abonaments__dates__item" data-cart="' +
                                    termin_id +
                                    '" data-termin_id="' +
                                    row.id +
                                    '">' +
                                    '              <input type="checkbox" tabindex="' +
                                    row.id +
                                    '" value="' +
                                    row.id +
                                    '"' +
                                    checkedVal +
                                    '>' +
                                    '              <div class="abonaments__dates__item__content">' +
                                    '                <div class="date">' +
                                    row.data +
                                    '</div>' +
                                    '                <div class="day">' +
                                    row.dzien +
                                    ' ' +
                                    row.godzina +
                                    '</div>' +
                                    '                <span class="btn btn--grey">' +
                                    translates.wybieram +
                                    '</span>' +
                                    '               </div>' +
                                    '             </label>';
                            });

                            $($('.js-alternatywne-terminy')[indexWierszaZTerminami]).html(
                                terminyHtml
                            );
                            //if ($(".abonaments__dates__slider").length > 0) {
                            $(alternatywneTerminyBox).each(function() {
                                if ($(this).hasClass('slick-initialized') === false) {
                                    $(this).slick({
                                        infinite: false,
                                        slidesToShow: 3,
                                        prevArrow:
                                            '<button type="button" class="slick-prev"></button>',
                                        nextArrow:
                                            '<button type="button" class="slick-next"></button>',
                                        mobileFirst: true,
                                        responsive: [
                                            {
                                                breakpoint: 1024,
                                                settings: {
                                                    slidesToShow: 3
                                                }
                                            },
                                            {
                                                breakpoint: 301,
                                                settings: {
                                                    slidesToShow: 1
                                                }
                                            },
                                            {
                                                breakpoint: 300,
                                                settings: 'unslick'
                                            }
                                        ]
                                    });
                                }
                            });
                            that.handleEvents();
                            setTimeout(that.makeSelectedVisible, 400);
                            //}
                        } else {
                            //$(alternatywneTerminyBox).slick('slickRemove',$('.slick-slide').index(this) - 1);

                            $(alternatywneTerminyBox)
                                .css({
                                    visibility: 'hidden',
                                    height: '1px'
                                })
                                .html('')
                                .removeClass('slick-initialized slick-slider');
                            $($('.js-koszyk-zmien-termn')[indexWierszaZTerminami]).html(
                                translates.zmien
                            );
                        }
                    }
                } else {
                    let popup = new Popup(
                        result.message ||
                        translates.pobieranie_terminow_karnetu_blad
                    );
                    popup.showPopup();
                }
            },
            error: function(xhr, status, error) {
                console.error(status);
                console.error(error);
                let popup = new Popup(translates.pobieranie_terminow_karnetu_blad);
                popup.showPopup();
            }
        });
    }

    //jeśli mamy dużo termnów w rzędzie a nasz wybrany termin jest "gdzieś daleko", czyli niewidoczny
    //to przy przeładowaniu strony przewijamy listę tak aby był widoczny
    makeSelectedVisible() {
        function switchNext() {
            let checkbox;
            let nextButton;
            let terminyQty;
            $.each($('.abonaments__dates__slider'), function(index, row) {
                terminyQty = 0;
                $.each($(row).find('.abonaments__dates__item'), function(
                    termin_index,
                    terminBox
                ) {
                    terminyQty++;
                    checkbox = $(terminBox).find('input[type="checkbox"]');
                    if (
                        $(checkbox).length === 1 &&
                        $(checkbox).is(':checked') &&
                        $(terminBox).attr('aria-hidden') === 'true'
                    ) {
                        nextButton = $(terminBox)
                            .parent()
                            .parent()
                            .parent()
                            .find('.slick-next');
                        if ($(nextButton).length === 1) {
                            $(nextButton).click();
                            setTimeout(switchNext, 200);
                        }
                    }
                });

                //jak mamy jeden termin to dziwnie się wyświetla na mobile. Ten kod ma to poprawić
                if (terminyQty === 1 && $('body').hasClass('mobile')) {
                    $(row)
                        .find('.slick-track')
                        .css({ width: $(row).width() + 'px' });
                    $(row)
                        .find('.abonaments__dates__item')
                        .css({ width: $(row).width() + 'px' });
                }
            });
        }

        setTimeout(switchNext, 500);
    }

    usunKarnet(idt_blokad) {
        const that = this;
        $.ajax({
            url: '/koszyk/index.html',
            method: 'get',
            data: {
                json: true,
                ajax_action: 'usun_karnet',
                idt_blokad: idt_blokad
            },
            success: function(result) {
                if (result && result.status === 'complete') {
                    location.reload();
                } else {
                    let popup = new Popup(
                        result.message || 'Wystąpił błąd podczas usuwania karnetu'
                    );
                    popup.showPopup();
                }
            },
            error: function(xhr, status, error) {
                console.error(status);
                console.error(error);
                let popup = new Popup(error);
                popup.showPopup();
            }
        });
    }

    ukryjCene(ukryjValue) {
        const that = this;
        $.ajax({
            url: '/koszyk/index.html',
            method: 'get',
            data: {
                json: true,
                ajax_action: 'ukryj_cene',
                ukryj_wartosc: ukryjValue
            },
            success: function(result) {
                if (result && result.status !== 'complete') {
                    let popup = new Popup(
                        result.message || 'Wystąpił błąd podczas ustawiania wzorca biletu'
                    );
                    popup.showPopup();
                }
            },
            error: function(xhr, status, error) {
                console.error(status);
                console.error(error);
                let popup = new Popup(error);
                popup.showPopup();
            }
        });
    }

    checkIfInputsValid() {
        let isValid = true;
        let invalidInputs = [];
        let messages = [];

        if (
            $('input#koszyk-niezalogowany_imie').length === 1 &&
            $.trim($('input#koszyk-niezalogowany_imie').val()) === ''
        ) {
            invalidInputs.push($('input#koszyk-niezalogowany_imie'));
            messages.push(translates.prosze_podac_imie);
        }

        if (
            $('input#koszyk-niezalogowany_nazwisko').length === 1 &&
            $.trim($('input#koszyk-niezalogowany_nazwisko').val()) === ''
        ) {
            invalidInputs.push($('input#koszyk-niezalogowany_nazwisko'));
            messages.push(translates.prosze_podac_nazwisko);
        }

        //adres email:
        if (
            $('input#koszyk-niezalogowany_email').length === 1 &&
            $('input#koszyk-niezalogowany_email2').length === 1
        ) {
            if ($.trim($('input#koszyk-niezalogowany_email').val()) === '') {
                invalidInputs.push($('input#koszyk-niezalogowany_email'));
                messages.push(translates.prosze_podac_adres_email);
            }

            if ($.trim($('input#koszyk-niezalogowany_email2').val()) === '') {
                invalidInputs.push($('input#koszyk-niezalogowany_email2'));
                messages.push(translates.prosze_powtorzyc_adres_email);
            }

            if (
                $.trim($('input#koszyk-niezalogowany_email2').val()) !==
                $.trim($('input#koszyk-niezalogowany_email').val())
            ) {
                invalidInputs.push($('input#koszyk-niezalogowany_email'));
                invalidInputs.push($('input#koszyk-niezalogowany_email2'));
                messages.push(translates.adresy_email_nie_sa_takie_same);
            }
        }

        // Faktura
        if ($('[name="koszyk-faktura"]').is(':checked')) {
            let fakturaRodzaj = parseInt($('.js-faktura_rodzaj').val()); // 1- osoba prywatna, 2 - fimra, instytucja
            console.log('faktura rodzaj:', fakturaRodzaj);
            if (fakturaRodzaj === 1) {
                if (
                    $('input#koszyk-faktura_imie').is(':visible') &&
                    $('input#koszyk-faktura_imie').length === 1 &&
                    $.trim($('input#koszyk-faktura_imie').val()) === ''
                ) {
                    invalidInputs.push($('input#koszyk-faktura_imie'));
                    messages.push(translates.prosze_podac_imie_osoby_do_faktury);
                }

                if (
                    $('input#koszyk-faktura_nazwisko').is(':visible') &&
                    $('input#koszyk-faktura_nazwisko').length === 1 &&
                    $.trim($('input#koszyk-faktura_nazwisko').val()) === ''
                ) {
                    invalidInputs.push($('input#koszyk-faktura_nazwisko'));
                    messages.push(translates.prosze_podac_nazwisko_osoby_do_faktury);
                }
            } else if (fakturaRodzaj === 2) {
                if (
                    $('input#koszyk-faktura_nazwa').is(':visible') &&
                    $('input#koszyk-faktura_nazwa').length === 1 &&
                    $.trim($('input#koszyk-faktura_nazwa').val()) === ''
                ) {
                    invalidInputs.push($('input#koszyk-faktura_nazwa'));
                    messages.push(translates.faktura_nazwa_brak);
                }

                if (
                    $('input#koszyk-faktura_nip').length === 1 &&
                    $.trim($('input#koszyk-faktura_nip').val()) === '' &&
                    $('input#koszyk-faktura_nip').is(':visible')
                ) {
                    invalidInputs.push($('input#koszyk-faktura_nip'));
                    messages.push(translates.faktura_nip_brak);
                }
            }

            if (
                $('input#koszyk-faktura_ulica').is(':visible') &&
                $('input#koszyk-faktura_ulica').length === 1 &&
                $.trim($('input#koszyk-faktura_ulica').val()) === ''
            ) {
                invalidInputs.push($('input#koszyk-faktura_ulica'));
                messages.push(translates.prosze_podac_ulice);
            }

            if (
                $('input#koszyk-faktura_numer_budynku').is(':visible') &&
                $('input#koszyk-faktura_numer_budynku').length === 1 &&
                $.trim($('input#koszyk-faktura_numer_budynku').val()) === ''
            ) {
                invalidInputs.push($('input#koszyk-faktura_numer_budynku'));
                messages.push(translates.prosze_podac_numer_budynku);
            }

            // if($('input#koszyk-faktura_numer_lokalu').length === 1 && $.trim($('input#koszyk-faktura_numer_lokalu').val()) === ''){
            //   invalidInputs.push($('input#koszyk-faktura_numer_lokalu'));
            //   messages.push(translates.prosze_podac_numer_lokalu);
            // }

            if (
                $('input#koszyk-faktura_kod').is(':visible') &&
                $('input#koszyk-faktura_kod').length === 1 &&
                $.trim($('input#koszyk-faktura_kod').val()) === ''
            ) {
                invalidInputs.push($('input#koszyk-faktura_kod'));
                messages.push(translates.prosze_podac_kod_pocztowy);
            }

            if (
                $('input#koszyk-faktura_miejscowosc').is(':visible') &&
                $('input#koszyk-faktura_miejscowosc').length === 1 &&
                $.trim($('input#koszyk-faktura_miejscowosc').val()) === ''
            ) {
                invalidInputs.push($('input#koszyk-faktura_miejscowosc'));
                messages.push(translates.prosze_podac_miejscowosc);
            }
        }

        if ($('[name="koszyk-adres_inny"]').is(':checked')) {
            if (
                $('input#koszyk-niezalogowany_ulica').length === 1 &&
                $.trim($('input#koszyk-niezalogowany_ulica').val()) === ''
            ) {
                invalidInputs.push($('input#koszyk-niezalogowany_ulica'));
                messages.push(translates.prosze_podac_ulice);
            }

            if (
                $('input#koszyk-niezalogowany_numer_domu').length === 1 &&
                $.trim($('input#koszyk-niezalogowany_numer_domu').val()) === ''
            ) {
                invalidInputs.push($('input#koszyk-niezalogowany_numer_domu'));
                messages.push(translates.prosze_podac_numer_budynku);
            }

            // if($('input#koszyk-niezalogowany_numer_mieszkania').length === 1 && $.trim($('input#koszyk-niezalogowany_numer_mieszkania').val()) === ''){
            //   invalidInputs.push($('input#koszyk-niezalogowany_numer_mieszkania'));
            //   messages.push(translates.prosze_podac_numer_lokalu);
            // }

            if (
                $('input#koszyk-niezalogowany_kod').length === 1 &&
                $.trim($('input#koszyk-niezalogowany_kod').val()) === ''
            ) {
                invalidInputs.push($('input#koszyk-niezalogowany_kod'));
                messages.push(translates.prosze_podac_kod_pocztowy);
            }

            if (
                $('input#koszyk-niezalogowany_miejscowosc').length === 1 &&
                $.trim($('input#koszyk-niezalogowany_miejscowosc').val()) === ''
            ) {
                invalidInputs.push($('input#koszyk-niezalogowany_miejscowosc'));
                messages.push(translates.prosze_podac_miejscowosc);
            }
        }

        $.each($('.koszyk-zgody input.required'), function(index, checkboxZgody) {
            if ($(checkboxZgody).is(':checked') === false) {
                invalidInputs.push($($('.koszyk-zgody input.required')[index]));
                messages.push(translates.wyrazenie_zgody_jest_wymagane);
            }
        });
        console.log(invalidInputs);
        if (invalidInputs.length > 0) {
            isValid = false;
        }

        let wybranyInputDostawy = $('[name="koszyk-sposobydostawy"]:checked');
        if ($(wybranyInputDostawy).length > 0) {
            //let adresWymagany = false;
            let dostawaLabel = $(wybranyInputDostawy).parent().find('.js-nazwa-sposobu-dost-bold');
            if ($(dostawaLabel).length > 0) {
                if (parseInt($(dostawaLabel).data('adres_wymagany')) === 1) {

                    if ($('#koszyk-dostawa_nazwa_firmy').length > 0 && $('#koszyk-dostawa_nazwa_firmy').val() === '' && $('#koszyk-dostawa_nazwa_firmy').is(':visible')) {

                        isValid = false;
                        invalidInputs.push($('input#koszyk-dostawa_nazwa_firmy'));
                        messages.push(translates.prosze_podac_imie_i_nazwisko_lub_nazwe_firmy_do_dostawy);
                    }

                    if ($('#koszyk-dostawa_adres').length > 0 && $('#koszyk-dostawa_adres').val() === '' && $('#koszyk-dostawa_adres').is(':visible')) {
                        isValid = false;
                        invalidInputs.push($('input#koszyk-dostawa_adres'));
                        messages.push(translates.prosze_podac_adres_do_dostawy);
                    }

                    if ($('#koszyk-dostawa_kod').length > 0 && $('#koszyk-dostawa_kod').val() === '' && $('#koszyk-dostawa_kod').is(':visible')) {
                        isValid = false;
                        invalidInputs.push($('input#koszyk-dostawa_kod'));
                        messages.push(translates.prosze_podac_kod_pocztowy_do_dostawy);
                    }

                    if ($('#koszyk-dostawa_miejscowosc').length > 0 && $('#koszyk-dostawa_miejscowosc').val() === '' && $('#koszyk-dostawa_miejscowosc').is(':visible')) {
                        isValid = false;
                        invalidInputs.push($('input#koszyk-dostawa_miejscowosc'));
                        messages.push(translates.prosze_podac_miejscowosc_do_dostawy);
                    }

                }
            }
        } else {
            if ($('[name="koszyk-sposobydostawy"]').length > 0) {
                isValid = false;
                invalidInputs.push($('input[name="koszyk-sposobydostawy"]'));
                messages.push('<span style="color: red; font-size: .9em;">' + translates.prosze_wybrac_sposob_dostawy + '</span>');
            }
        }

        return {
            isValid: isValid,
            invalidInputs: invalidInputs,
            messages: messages
        };
    }

    /*
    Ustawia nowy sposób dostawy na podstawie podanego ID dostawy
    */
    ustawSposobDostawy(dostawa_id) {
        const that = this;
        $.ajax({
            url: '/koszyk/index.html',
            method: 'get',
            beforeSend: Tools.preloaderShow,
            complete: Tools.preloaderHide,
            data: {
                json: true,
                ajax_action: 'zmien_sposob_dostawy',
                dostawa_id: dostawa_id
            },
            success: function(result) {
                if (result && result.status === 'complete') {
                    let kosztDostawy = result.data.koszt_dostawy;
                    if (parseFloat(kosztDostawy) === 0.0) {
                        $('.js-dostawa-row').hide();
                    } else {
                        $('.js-dostawa-row').show();
                    }
                    that.zwrocZawartoscKoszyka();
                } else {
                    let popup = new Popup(
                        result.message ||
                        'Wystąpił błąd podczas aktualizacji sposobu dostawy'
                    );
                    popup.showPopup();
                }
            },
            error: function(xhr, status, error) {
                console.error(status);
                console.error(error);
                let popup = new Popup(error);
                popup.showPopup();
            }
        });
    }

    /*Funkcja przesyła kod rabatowy*/
    zastosujRabat(kod) {
        const that = this;

        $.ajax({
            url: '/koszyk/index.html',
            method: 'get',
            data: {
                json: true,
                ajax_action: 'zastosuj_kod_rabatowy',
                koszyk_v_kod: kod
            },
            success: function(result) {
                if (result && result.status === 'complete') {
                    //console.log(result);
                    window.location.reload();
                    //that.zwrocZawartoscKoszyka();
                } else {
                    let popup = new Popup(
                        result.message ||
                        'Wystąpił błąd podczas wprowadzania kodu rabatowego'
                    );
                    popup.showPopup();
                }
            },
            error: function(xhr, status, error) {
                console.error(status);
                console.error(error);
                let popup = new Popup(error);
                popup.showPopup();
            }
        });
    }

    /*Funkcja przesyła numer karty przedplaconej*/
    wprowadzNumerKartyPrzedplaconej(karta_przedplacona_numer) {
        const that = this;
        $.ajax({
            url: '/koszyk/index.html',
            method: 'get',
            data: {
                json: true,
                ajax_action: 'wprowadz_karte_przedplacona',
                karta_przedplacona_numer: karta_przedplacona_numer
            },
            success: function(result) {
                if (result && result.status === 'complete') {
                    let popup = new Popup(
                        translates.karta_przedplacona_dodana
                    );
                    popup.showPopup();
                    that.zwrocZawartoscKoszyka();
                } else {
                    let popup = new Popup(
                        result.message || translates.karta_przedplacona_blad
                    );
                    popup.showPopup();
                }
            },
            error: function(xhr, status, error) {
                let popup = new Popup(translates.karta_przedplacona_blad);
                popup.showPopup();
            }
        });
    }

    /**
     Funkcja zmienia pozycję cennika gdy wybierzemy inny rodzaj biletu
     */
    zmienPozycjeCennika(params) {
        const that = this;
        params.zmien_pozycje_cennika = 1;
        $.ajax({
            url: '/rezerwacja/numerowane.html',
            method: 'get',
            data: params,
            success: function(result) {
                if (result && result.status === 'success') {
                    that.zwrocZawartoscKoszyka();
                } else {
                    let popup = new Popup(
                        result.message ||
                        translates.pozycja_cennika_update_err
                    );
                    popup.showPopup();
                }
            },
            error: function(xhr, status, error) {
                console.error(status);
                console.error(error);
                let popup = new Popup(translates.pozycja_cennika_update_err);
                popup.showPopup();
            }
        });
    }

    /**
     Funkcja pobiera aktualną zawartość koszyka. Ta zawartość jest potrzebna np gdy wchodzimy na stronę a już mamy dodane jakieś bilety w koszyku
     */
    zwrocZawartoscKoszyka() {
        const that = this;
        $.ajax({
            url: '/rezerwacja/numerowane.html',
            method: 'get',
            data: {
                json: true,
                jsonType: 'koszyk_zawartosc'
            },
            success: function(json) {
                if (json && json.status === 'success') {
                    that.wypiszZawartoscKoszyka(json.data);
                } else {
                    let popup = new Popup(
                        json.message ||
                        'wystąpił błąd podczas pobierania zawartości koszyka'
                    );
                    popup.showPopup();
                }
            },
            error: function(xhr, status, error) {
                console.error(status);
                console.error(error);
                let popup = new Popup(error);
                popup.showPopup();
            }
        });
    }

    /**
     Funkcja wypisuje listę wybranych biletów w aktualnie wyświetlanym terminie w mini-koszyku po prawej stronie,
     aktualizuje również liczbę biletów oraz kwotę do zapłaty pod przyciskiem koszyka w menu
     */
    wypiszZawartoscKoszyka(json) {
        const that = this;
        let waluta = json.waluta;

        //aktualizujemy ilość w koszyku oraz sumę w koszyku linku koszyka w menu na górze
        $('.fr-cart__counter').html(json.liczba_biletow);
        $('.fr-cart__amount').html(json.koszyk_razem);

        //aktualizujemy total:
        $('#js-zamowienie-total').html(
            json.koszyk_razem_bez_dostawy + ' ' + waluta
        );
        $('.js-dostawa-total').html(json.koszyk_dostawa_cena);
        $('.js-towary-plus-dostawa').html(
            (
                parseFloat(json.koszyk_dostawa_cena) +
                parseFloat($('[name="towaryTotal"]').val())
            ).toFixed(2)
        );
        $('.js-dostawa-nazwa').html(json.koszyk_dostawa_nazwa);
        $('.js-do-zaplaty-total').html(json.koszyk_do_zaplaty);
        let identyfikatorCeny;
        let selectWrapper;
        let poleSelect;
        let klasyPolaSelect;

        //generujemy listę biletów wybranych w aktualnym terminie:

        let podgladKoszykaHtml =
            '<div class="short-cart-item__header">' +
            translates.bilety +
            '</div>';
        let terminCounter = 0;
        $.each(json.numerowane, function(termin_index, termin) {
            let biletyWTerminieKwotaRazem = 0;
            $.each(termin.wybrane_bilety, function(
                id_pozycji_cennika,
                bilety_dla_pozycji_cennika
            ) {
                $.each(bilety_dla_pozycji_cennika, function(
                    bilet_index,
                    wybrane_miejsce
                ) {
                    biletyWTerminieKwotaRazem += parseFloat(wybrane_miejsce.cena);

                    $(
                        '#koszyk_miejsce_wartosc_' +
                        termin.termin_id +
                        '_' +
                        wybrane_miejsce.miejsce_id
                    ).html(wybrane_miejsce.cena);

                    selectWrapper = $(
                        '#rodzaj_biletu_select_wrapper_' +
                        termin.termin_id +
                        '_' +
                        wybrane_miejsce.miejsce_id
                    );

                    poleSelect = $(selectWrapper).find('select');
                    if ($(poleSelect).length > 0) {
                        klasyPolaSelect = $(poleSelect).attr('class');
                        $(selectWrapper).html(
                            wybrane_miejsce.pole_select.replace(
                                'koszyk_miejscec',
                                'koszyk-miejsce'
                            )
                        );
                        poleSelect = $(selectWrapper).find('select');
                        poleSelect.attr('class', klasyPolaSelect);
                    }
                });
            });

            $('.js-termin-total-' + termin.termin_id + ' ' + '.kwota').html(
                biletyWTerminieKwotaRazem.toFixed(2)
            );

            //zawartosc dla podglądu koszyka, który pojawia się na górze strony po najechaniu na koszyk w menu:

            $.each(termin.wybrane_bilety, function(
                id_pozycji_cennika,
                bilety_dla_pozycji_cennika
            ) {
                if (json.numerowane.length > 1) {
                    let optMarginClass = '';
                    if (terminCounter > 0) {
                        optMarginClass = 'mt-2';
                    }
                    podgladKoszykaHtml += `<div class="text-left font-weight-bolder ${optMarginClass}">${
                        termin.termin_data_sformatowana
                    } godz. ${termin.termin_godzina}</div>`;
                }
                podgladKoszykaHtml += `
        <div class="short-cart-item__content">
            <div class="img-box"><img src="${
                    termin.zdjecie_sciezka
                }" alt=""></div>
            <div class="content-box">
                <div class="name">${termin.wydarzenie_nazwa}</div>
                <div class="price">${
                    bilety_dla_pozycji_cennika[0].cena
                } ${waluta}</div>
                <div class="num-box"><span class="num-txt">Liczba: </span><span class="num">${
                    bilety_dla_pozycji_cennika.length
                }</span></div>
            </div>
        </div>`;
            });
        });

        //$(".cart-right-site-items").html(koszTerminuHtml);
        $('.short-cart-item-tickets').html(podgladKoszykaHtml);

        //podsumowanie dla terminu(lista biletów po prawej stronie)
        // if (biletyWTerminieIlosc === 0) {
        //   $(".tickets__cart__summary__quantity").html(
        //     numFn.translate("brak_biletow")
        //   );
        //   $(".tickets__cart__summary__price").html("");
        // } else {
        //   $(".tickets__cart__summary__quantity").html(
        //     biletyWTerminieIlosc + " " + json.bilety_odmiana
        //   );
        //   $(".tickets__cart__summary__price").html(
        //     biletyWTerminieKwotaRazem.toFixed(2) + " " + waluta
        //   );
        // }
        that.events();
    }

    sprawdzPodsumowanie() {
        const that = this;
        if (
            $('#summary-tab').hasClass('active') ||
            $('#delivery-tab').hasClass('active')
        ) {
            that.pobierzPodsumowanie();
        }
    }

    pobierzPodsumowanie() {
        const that = this;
        $.ajax({
            url: '/koszyk/podsumowanie.html',
            method: 'get',
            data: {
                json: true
            },
            success: function(json) {
                if (json.status === 'success') {
                    that.settings.podsumowanieDane = json.data;
                    that.wypiszPodsumowanie();
                    if ($('body').hasClass('mobile')) {
                        that.wypiszPodsumowanieDlaZakladkiDostawy();
                        that.wypiszWycieczki();
                    }
                } else {
                    let popup = new Popup(json.message);
                    popup.showPopup();
                }
            },
            error: function(xhr, status, error) {
                console.error(status);
                console.error(error);
                let popup = new Popup(error);
                popup.showPopup();
            }
        });
    }

    wypiszPodsumowanie() {
        const that = this;
        let json = that.settings.podsumowanieDane;

        //DANE PODSTAWOWE:
        let kontrahent = json.kontrahent;

        $('.js-kontrahent-imie').html(kontrahent.imie);
        $('.js-kontrahent-nazwisko').html(kontrahent.nazwisko);
        $('.js-kontrahent-email').html(kontrahent.email);
        $('.js-kontrahent-telefon').html(
            kontrahent.telefon
                ? kontrahent.telefon
                : translates.nie_podano
        );
        if (
            kontrahent.adres.ulica != kontrahent.daneDoFaktury.ulica &&
            kontrahent.adres.ulica != ''
        ) {
            $('.js-kupujacy-adres').show();
            $('.js-kontrahent-ulica').html(kontrahent.adres.ulica);
            $('.js-kontrahent-numer-budynku').html(kontrahent.adres.numerBudynku);
            if (kontrahent.adres.numerLokalu) {
                $('.js-kontrahent-numer-lokalu').html(
                    '/' + kontrahent.adres.numerLokalu
                );
            }
            $('.js-kontrahent-miejscowosc').html(kontrahent.adres.miejscowosc);
            $('.js-kontrahent-kod').html(kontrahent.adres.kodPocztowy);
        } else {
            $('.js-kupujacy-adres').hide();
        }

        //DANE DO FAKTURY:
        if (kontrahent.fakturaVat === 'tak') {
            let daneDoFaktury = kontrahent.daneDoFaktury;
            $('.js-podsumowanie-fvat').show();

            if (daneDoFaktury.nazwa) {
                $('.js-podsumowanie-fvat-nazwa').html(daneDoFaktury.nazwa);
            } else {
                $('.js-podsumowanie-fvat-nazwa').html(
                    daneDoFaktury.imie + ' ' + daneDoFaktury.nazwisko
                );
            }

            if (daneDoFaktury.nip) {
                $('.js-nip-visibility').show();
                $('.js-podsumowanie-fvat-nip').html(daneDoFaktury.nip);
            }
            $('.js-podsumowanie-fvat-ulica').html(daneDoFaktury.ulica);
            let numer = daneDoFaktury.numerBudynku;
            if (daneDoFaktury.numerLokalu) {
                numer = numer + '/' + daneDoFaktury.numerLokalu;
            }
            $('.js-podsumowanie-fvat-numer').html(numer);
            $('.js-podsumowanie-fvat-kod').html(daneDoFaktury.kodPocztowy);
            $('.js-podsumowanie-fvat-miejscowosc').html(daneDoFaktury.miejscowosc);
            if (daneDoFaktury.kraj) {
                $('.js-podsumowanie-faktura-kraj').show();
                $('.js-podsumowanie-fvat-kraj').html(daneDoFaktury.kraj);
            } else {
                $('.js-podsumowanie-faktura-kraj').hide();
            }
        } else {
            $('.js-podsumowanie-fvat').hide();
        }

        //SPOSÓB DOSTAWY
        let wybranaDostawa = json.dostawa;
        $('.js-podsumowanie-dostawa-nazwa').html(wybranaDostawa.nazwa);
        let dostawaCenaSformatowana = '';
        if (wybranaDostawa.cena > 0) {
            $('.js-wybrany-adres-dostawy').show();
            dostawaCenaSformatowana =
                '(+ ' + wybranaDostawa.cena + ' ' + json.waluta + ') ';
        } else {
            $('.js-wybrany-adres-dostawy').hide();
        }
        $('.js-podsumowanie-dostawa-cena').html(dostawaCenaSformatowana);
        $('.js-podsumowanie-dostawa-cena2').html(wybranaDostawa.cena);
        $('.js-podsumowanie-dostawa-opis').html(wybranaDostawa.opis);

        //ADRES DOSTAWY:
        let adresDostawy = json.dostawaAdres;
        $('.js-podsumowanie-dostawa-nazwa-firmy').html(adresDostawy.nazwaFirmy);
        $('.js-podsumowanie-dostawa-adres').html(adresDostawy.adres);
        $('.js-podsumowanie-dostawa-kod').html(adresDostawy.kodPocztowy);
        $('.js-podsumowanie-dostawa-miejscowosc').html(adresDostawy.miejscowosc);
        $('.js-podsumowanie-dostawa-kraj').html(adresDostawy.kraj);

        //INNE:

        let komentarzDoZamowienia;
        if (json.komentarz && json.komentarz.trim() !== '') {
            komentarzDoZamowienia = json.komentarz;
        } else {
            komentarzDoZamowienia = translates.nie_podano;
        }
        $('.js-zamowienie-komentarz').html(komentarzDoZamowienia);

        //KWOTY:
        $('.js-podsumowanie-do-zaplaty').html(json.kwoty.doZaplaty);
        if (json.kwoty.wartoscProwizji > 0) {
            $('.js-podsumowanie-wartosc-prowizji-wrapper').show();
            $('.js-podsumowanie-wartosc-prowizji').html(json.kwoty.wartoscProwizji);
        } else {
            $('.js-podsumowanie-wartosc-prowizji-wrapper').hide();
        }

        that.wypiszTerminy();
        that.wypiszTowary();
        that.wypiszWycieczki();
        that.wypiszKarnety();
    }

    // test(){
    //   let arr = [
    //     {title: 'i_1_1.jpg (mini)', value: '/images/strony/mini/i_1_1.jpg'},
    //     {title: 'i_1_1.jpg (full)', value: '/images/strony/full/i_1_1.jpg'},
    //     {title: 'i_1_1.jpg', value: '/images/strony/i_1_1.jpg'},
    //     {title: 'i_44.jpg (mini)', value: '/images/strony/mini/i_44.jpg'},
    //     {title: 'i_44.jpg (full)', value: '/images/strony/full/i_44.jpg'},
    //     {title: 'i_44.jpg', value: '/images/strony/i_44.jpg'}
    //     ];
    // }

    wypiszPodsumowanieDlaZakladkiDostawy() {
        const that = this;
        let podsumowanie = that.settings.podsumowanieDane;

        let iloscTerminow = 0;
        $.each(podsumowanie.terminy, function() {
            iloscTerminow++;
        });

        if (podsumowanie.terminy && iloscTerminow > 0) {
            $('.js-pods-bilety').show();
            $('.js-delivery-tab-bilety-razem').show();

            let podsBiletyHtml = '<div class="fr-label">Bilety</div>';
            $.each(podsumowanie.terminy, function(termin_id, terminData) {
                podsBiletyHtml +=
                    '' +
                    '                      <div class="js-pods-termin">' +
                    '                        <div><strong>' +
                    terminData.kategoria +
                    ': ' +
                    terminData.wydarzenieNazwa +
                    '</strong></div>' +
                    '                        <div style="font-size: smaller" class="mb-1"><strong>' +
                    terminData.data +
                    ' ' +
                    terminData.godzina +
                    '</strong></div>' +
                    '                        <div class="row">' +
                    '                          <div class="col-7"><strong>' +
                    translates.rodzaj_biletu +
                    '</strong></div>' +
                    '                          <div class="col-2 text-right" style="text-transform:capitalize"><strong>' +
                    translates.ilosc +
                    '</strong></div>' +
                    '                          <div class="col-3 text-right" style="text-transform:capitalize"><strong>' +
                    translates.cena +
                    '</strong></div>' +
                    '                        </div>';
                $.each(terminData.bilety, function(ind, biletData) {
                    podsBiletyHtml +=
                        '<div class="row fr-mb-15">' +
                        '                       <div class="col-7">' +
                        biletData.pozycja_cennika_nazwa +
                        '</div>' +
                        '                       <div class="col-2 text-right">' +
                        biletData.ilosc +
                        '</div>' +
                        '                       <div class="col-3 text-right">' +
                        (
                            parseInt(biletData.ilosc) * parseFloat(biletData.cena_brutto)
                        ).toFixed(2) +
                        ' ' + currency + '</div>' +
                        '                     </div>';
                });

                podsBiletyHtml += '  </div>';
            });

            $('.js-pods-bilety').html(podsBiletyHtml);
            $('.js-pods-suma-bilety').html(podsumowanie.kwoty.wartoscBiletow);
            $('.js-pods-do-zaplaty').html(podsumowanie.kwoty.doZaplaty);

            let prowizja = podsumowanie.kwoty.wartoscProwizji;
            if (prowizja > 0) {
                $('.js-pods-prowizja')
                    .parent()
                    .parent()
                    .show();
                $('.js-pods-prowizja').html(prowizja);
            } else {
                $('.js-pods-prowizja')
                    .parent()
                    .parent()
                    .hide();
            }
        } else {
            $('.js-pods-bilety').hide();
        }
    }

    wypiszTerminy() {
        const that = this;
        let terminy = that.settings.podsumowanieDane.terminy;
        let terminyHtml = '';

        $.each(terminy, function(terminId, termin) {
            terminyHtml +=
                '                            <div class="row">\n' +
                '                              <div class="col-12" ' +
                (terminy.length > 1 ? '' : 'style="display: none"') +
                '>' +
                termin.data +
                ' godz. ' +
                termin.godzina +
                '</div>\n' +
                '                              <div class="col-7"><strong>' +
                termin.kategoria +
                ': ' +
                termin.wydarzenieNazwa +
                '</strong></div>\n' +
                '                              <div class="col-2 text-right"><strong>' +
                translates.ilosc +
                '</strong></div>\n' +
                '                              <div class="col-3 text-right"><strong>' +
                translates.cena +
                '</strong></div>\n' +
                '                            </div>\n' +
                '\n' +
                '                            <div class="row fr-mb-15">\n';
            $.each(termin.bilety, function(pozycjaCennikaId, biletZPozycjiCennika) {
                terminyHtml +=
                    '<div class="col-7">' +
                    biletZPozycjiCennika.pozycja_cennika_nazwa +
                    '<span class="text-nowrap">(' +
                    biletZPozycjiCennika.cena_brutto + ' ' + currency +
                    ') </span>' +
                    '</div>\n' +
                    '<div class="col-2 text-right">' +
                    biletZPozycjiCennika.ilosc +
                    '</div>\n' +
                    '<div class="col-3 text-right">' + (biletZPozycjiCennika.cena_brutto * biletZPozycjiCennika.ilosc).toFixed(2) + ' ' + currency + '</div>';
            });

            terminyHtml += '                            </div>';
        });

        $('.js-delivery-tab-bilety').html(terminyHtml); // wypisuje listę biletów na zakładce z dostawą
        $('.js-podsumowanie-terminy').html(terminyHtml); //wypisuje listę biletów na zakładce z podsumowaniem
    }

    wypiszTowary() {
        const _this = this;
        let towary = _this.settings.podsumowanieDane.towary;
        let sposobDostawy = _this.settings.podsumowanieDane.dostawa;
        //console.log(sposobDostawy);

        let frSummProducts = $('#fr-summ-products');
        let frSummProductsPodsumowanie = $('#fr-summ-products-podsumowanie');
        let towaryHtml = '         <div class="fr-label">Produkty</div>';
        let towaryKwotaRazem = 0;
        let sposobDostawyCena = sposobDostawy.cena === '' || sposobDostawy.cena === null ? '0.00' : sposobDostawy.cena;
        $.each(towary, function(index, row) {
            towaryKwotaRazem += row.ilosc * row.cena_sztuka;
            towaryHtml +=
                '<div class="row">' +
                '             <div class="col-7">' +
                row.nazwa +
                '</div>' +
                '             <div class="col-2 text-right">' +
                row.ilosc +
                '</div>' +
                '             <div class="col-3 text-right">' +
                row.cena_sztuka +
                ' ' + currency + '</div>' +
                '           </div>';
        });

        towaryHtml += '<input type="hidden" name="towaryTotal" value="' + towaryKwotaRazem + '">';
        if (sposobDostawy.id > 0) {
            towaryHtml += '<div class="row">' +
                '                <div class="col-9 js-dostawa-nazwa">' + sposobDostawy.nazwa + '</div>' +
                '<div class="col-3 text-right "><span class="js-dostawa-total">' +
                sposobDostawyCena +
                '</span> ' + currency + '</div>' +
                '                <div class="w-100 fr-summ-sepa"></div>' +
                '              </div>' +
                '              <div class="row">' +
                '                <div class="col-9"><strong>' + translates.suma + '</strong></div>' +
                '                <div class="col-3 text-right"><strong>' +
                '                  <span class="js-towary-plus-dostawa">' +
                (parseFloat(towaryKwotaRazem) + parseFloat(sposobDostawyCena)).toFixed(2) +
                '                  </span> ' + currency + '</strong>' +
                '                </div>' +
                '                <div class="w-100 fr-summ-sepa fr-summ-sepa--x2"></div>' +
                '              </div>';
        }
        frSummProducts.html(towaryHtml);
        frSummProductsPodsumowanie.html(towaryHtml);
    }

    wypiszWycieczki() {
        const _this = this;
        let wycieczki = _this.settings.podsumowanieDane.wycieczki;
        let frSummTour = $('#fr-summ-tour');
        let frSummTourPodsumowanie = $('#fr-summ-tour-podsumowanie');
        let suma = 0;
        let html = '';

        function wypiszBilety(bilety) {
            let html = '';

            if (bilety.length > 0) {
                bilety.forEach(bilet => {
                    let extract = parseFloat(
                        new RegExp(/^[1-9]{1}[0-9.]+/).exec(bilet.wartosc)[0]
                    );
                    suma += extract;
                    html += '<div class="row">' +
                        '<div class="col-7">' + bilet.nazwaPozycji + '</div>' +
                        '<div class="col-2 text-right">' + bilet.ilosc + '</div>' +
                        '<div class="col-3 text-right">' + bilet.wartosc + '</div>' +
                        '</div>';
                });
            }

            return html;
        }

        function wypiszDzienTygodnia(wycieczka) {
            let data = new Date(
                wycieczka.termin_data_niesformatowana.replace('/[-]/', ', ')
            );
            let dzienTygodnia = data.getDay();

            return dzienTygodnia;
        }

        if (!Array.isArray(wycieczki)) {
            html += '<div class="fr-label">' + translates.wycieczki + '</div>';

            for (const key in wycieczki) {
                if (wycieczki.hasOwnProperty(key)) {
                    const wycieczka = wycieczki[key];
                    const bilety = wycieczka.bilety;

                    html += '<div class="row mt-2">' +
                        '<div class="col-7">' +
                        '<strong>' + wycieczka.termin_data + ' ' + wycieczka.termin_godzina + '</strong>' +
                        '</div>' +
                        '<div class="col-2 text-right"><strong>' + translates.ilosc + '</strong></div>' +
                        '<div class="col-3 text-right"><strong>' + translates.cena + '</strong></div>' +
                        '</div>' + wypiszBilety(bilety);
                }
            }

            html += '<div class="row">' +
                '<div class="w-100 fr-summ-sepa"></div>' +
                '<div class="col-6"><strong>' + translates.suma + '</strong></div>' +
                '<div class="col-6 text-right"><strong>' + suma.toFixed(2) + '</strong></div>' +
                '</div>';

            html += '</div>';
        }

        if (html === '') {
            frSummTour.addClass('d-none').html(html);
        } else {
            frSummTour.removeClass('d-none').html(html);
            frSummTourPodsumowanie.html(html);
        }
    }

    wypiszKarnety() {
        const that = this;
        let karnety = that.settings.podsumowanieDane.karnety;

        let abonamentyHtml =
            '<div class="row">\n' +
            '                              <div class="col-7"><strong>' +
            karnety.nazwa +
            '</strong></div>\n' +
            '                              <div class="col-2 text-right"><strong>' +
            translates.ilosc +
            '</strong></div>\n' +
            '                              <div class="col-3 text-right"><strong>' +
            translates.cena +
            '</strong></div>\n' +
            '                            </div>\n' +
            '                            <div class="row">\n' +
            '                              <div class="col-7">' +
            karnety.strefaCenowa +
            '</div>\n' +
            '                              <div class="col-2 text-right">' +
            karnety.ilosc +
            '</div>\n' +
            '                              <div class="col-3 text-right">' +
            karnety.wartosc_karnetow_dla_blokady +
            ' ' + currency + '</div>\n' +
            '                              <div class="w-100 fr-summ-sepa"></div>\n' +
            '                            </div>\n' +
            '                            <div class="row">\n' +
            '                              <div class="col-6"><strong>' +
            translates.suma +
            '</strong></div>\n' +
            '                              <div class="col-6 text-right"><strong>' +
            karnety.wartosc_wszystkich_karnetow +
            ' ' + currency + '</strong></div>\n' +
            '                            </div>';

        $('.js-delivery-tab-abonamenty').html(abonamentyHtml); // wypisuje listę abonamentów na zakładce z dostawą
        $('.js-podsumowanie-abonamenty').html(abonamentyHtml); //wypisuje listę abonamentów na zakładce z podsumowaniem
    }

    applySettingsForMobile() {
        $('.cart-hideprice .checkbox__content').addClass(
            'checkbox__content--small'
        );
    }

    /*
    gdy zalogowany użytkownik przełącza dane do faktur to wybrane dane ustawiają pola hidden z id oraz identyfikatorem wybranych danych,
    przy odświeżaniu strony na zakładce dostawy jednak te dane automatycznie się nie ustawiają. Ta funkcja naprawia ten błąd
    * */
    ustawDaneDoFaktur() {
        let checkedDfSelector = $(
            '[name="koszyk-zachowane_dane_do_faktur"]:checked'
        );

        if (checkedDfSelector.length > 0) {
            let wybraneDaneDoFakturId = $(checkedDfSelector).val();
            if (wybraneDaneDoFakturId) {
                let identElem = $(checkedDfSelector)
                    .parent()
                    .find('.js-df-identyfikator');

                let identyfikator = '';
                if (identElem) {
                    identyfikator = $(identElem).data('identyfikator');
                }

                $('#koszyk-faktura_id_kontrahenta').val(wybraneDaneDoFakturId);
                $('#koszyk-faktura_identyfikator_kontrahenta').val(identyfikator);
            }
        }
    }

    init() {
        this.events();
        //this.ustawDaneDoFaktury();

        if ($('#delivery-tab').hasClass('active')) {
            if ($('[name="koszyk-adres_inny"]').is(':checked')) {
                $('#collapseAdres').addClass('show');
            } else {
                $('#collapseAdres').removeClass('show');
            }
        }
        this.sprawdzPodsumowanie();
        if ($('body').hasClass('mobile')) {
            this.applySettingsForMobile();
        }

        this.ustawDaneDoFaktur();
    }
}

export default Koszyk;
